export const PlanType = Object.freeze({
  BASIC: 0,
  STANDARD: 1,
  STANDARD_PLUS_INTEGRATIONS: 2,
  PREMIUM: 3,
});
